<template>
  <div class="border px-l">
    <h2>Import images from Dropbox</h2>
    <div v-if="dropboxLoggedIn">
      <b-list-group>
        <b-list-group-item
          class="d-flex justify-content-between align-items-center"
          variant="primary"
        >{{crumbText}}</b-list-group-item>
        <b-list-group-item
          v-if="path.length > 1"
          class="d-flex justify-content-between align-items-center"
          variant="dark"
          button
          @click="popPath"
        >..</b-list-group-item>
        <b-list-group-item
          class="d-flex justify-content-between align-items-center"
          v-for="item in itemsAtCurrentPath"
          :key="item.id"
          button
          @click="buttonAction(item)"
        >
          {{item.name}}
          <b-badge variant="primary" v-show="item['.tag'] == 'folder'">[folder]</b-badge>
        </b-list-group-item>
      </b-list-group>
    </div>
    <div v-else>
      <p>no dropbox account connected</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import dbx from "@/dropboxConfig";

export default {
  data() {
    return { path: [""] };
  },
  computed: {
    ...mapGetters({
      dropboxUsersFullAccount: "dropbox/usersFullAccount",
      dropboxLoggedIn: "dropbox/loggedIn",
      structure: "dropbox/structure"
    }),
    itemsAtCurrentPath() {
      return this.structure.filter(item => {
        return (
          item.path_lower
            .split("/")
            .slice(0, -1)
            .join("/") == this.path.join("/") &&
          (item[".tag"] == "folder" ||
            (item[".tag"] == "file" &&
              ["png", "mpg", "gif", "mpeg"].includes(
                item.path_lower.split(".").slice(-1)[0]
              )))
        );
      });
    },
    crumbText() {
      return (
        this.dropboxUsersFullAccount.name.display_name + this.path.join(" > ")
      );
    }
  },
  methods: {
    buttonAction(item) {
      if (item[".tag"] == "folder") {
        this.pushPath(item.path_lower.split("/").slice(-1));
      } else if (item[".tag"] == "file") {
        dbx
          .filesGetTemporaryLink({ path: item.path_lower })
          .then(result =>
            this.$emit("fileSelected", {
              name: result.metadata.name,
              path: result.metadata.path,
              URL: result.link
            })
          )
          .catch(error => {
            console.log(error);
          });
      }
    },
    pushPath(newPath) {
      this.path.push(newPath);
    },
    popPath() {
      this.path.pop();
    }
  }
};
</script>

